import React, { useCallback, useEffect, useState, memo } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Step, StepLabel, Stepper } from '@mui/material';
import { EnhancedRoute } from '../EnhancedRoute';
import './steps.css';

export type StepsArray = { path: string; screen: Function; step: number; label: string }[];

type StepsRouterProps = {
    steps: StepsArray;
    skipSteps: number[];
};

const StepsRouterNoMemo = (props: StepsRouterProps) => {
    const { steps, skipSteps } = props;
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = React.useState<{
        [k: number]: boolean;
      }>({});

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const firstStepPath = steps[0].path;
        navigate(firstStepPath);
    }, []);

    const getCfurrentStep = useCallback(() => {
        if (location.pathname && steps.length) {
            const step = steps.find((item) => item.path === location.pathname);
            return step ? step.step : 0;
        }
    }, [location.pathname, steps])

    const findActiveStep = useCallback(() => {
        const stepIndex = getCfurrentStep() ?? 0;
        const skipedStepBefore = skipSteps.filter(x => x < stepIndex).length;
        return stepIndex - skipedStepBefore;
    }, [location.pathname, steps, getCfurrentStep]);

    const setCompletedSteps  = useCallback(() => {
        const stepIndex = getCfurrentStep() ?? 0;
        const newCompleted : {[k: number]: boolean;} = {};
        steps.map(step => {
            if(step.step < stepIndex &&  skipSteps.indexOf(step.step) == -1){
                newCompleted[step.step] = true;
            }
        }); 
        setCompleted(newCompleted);
    }, [location.pathname, steps]);

    useEffect(() => {
        const step = findActiveStep() || 0;
        setActiveStep(step);
        window.scrollTo(0, 0);
        setCompletedSteps()
    }, [location, findActiveStep, setCompletedSteps]);

    const renderRoutes = (steps: { path: string; screen: Function }[]) => {
        return (
            <>
                {steps.map((step, index) => (
                    <Route
                        key={index}
                        path={step.path}
                        element={
                            <EnhancedRoute
                                steps={steps}
                                index={index}
                                Element={step.screen}
                                skipSteps={skipSteps}
                            />
                        }
                    />
                ))}
            </>
        );
    };

    let rowNo= 0;
    const getRowNo = () =>{
        rowNo = rowNo + 1;
        return rowNo;
    };

    return (
        <>
            <Stepper nonLinear activeStep={activeStep} alternativeLabel className="stepper">
                {steps.map((label, index) => (
                    skipSteps.indexOf(index) == -1 &&
                    <Step key={index} completed={completed[index]}>
                        <StepLabel icon={getRowNo()}>
                            <div className="stepper-label">{label.label}</div>
                        </StepLabel>
                    </Step>
                    
                ))}
            </Stepper>
            <Routes>{renderRoutes(steps)}</Routes>
        </>
    );
};

const StepsRouter = memo(StepsRouterNoMemo,(prevProps, nextProps) => {
        if (prevProps.skipSteps === nextProps.skipSteps) {
            return true; // props are equal
        }
        return false; // props are not equal -> update the component
    }
);

export default StepsRouter;
